import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type { EmoneyReconciliationDto } from "@/features/wallet/api/dto";

/**
 * Rapprochement quotidien circulation ↔ net émis
 * (`GET /EmoneyIssuances/reconciliation?currency=`). `differenceMinor`
 * doit être nul.
 */
export const useEmoneyReconciliation = (currency: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_EMONEY_RECONCILIATION(currency),
    queryFn: () =>
      fetchDataGet<EmoneyReconciliationDto>({
        url: walletEndpoints.emoneyIssuances.reconciliation,
        queryParams: currency ? { currency } : {},
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(currency),
  });
